<div class="calendar-filter">
  <div class="calendar-filter__container-group">
    <atom-input-checkbox
      #checkboxGroup
      [ngClass]="checkboxClass"
      [optionsList]="calendarOptions"
      [isMultiple]="false"
      (changed)="onCalendarTypeChange($event)">
    </atom-input-checkbox>
  </div>

  <!-- Contenedor general de calendarios -->
  <div *ngIf="selectedCalendarType" [ngClass]="calendarClass">
    <!-- Calendario para rango de días -->
    <div *ngIf="selectedCalendarType === 'range'" class="calendar-input">
      <atom-date-range [title]="'DATES.Rango de fechas'" (rangeChange)="onDateRangeChange($event)"></atom-date-range>
    </div>

    <!-- Calendario para rango de meses -->
    <div *ngIf="selectedCalendarType === 'monthRange'" class="calendar-input">
      <atom-month-range (monthRangeSelected)="onDateRangeSelected($event)"></atom-month-range>
    </div>

    <!-- Calendario para fecha individual -->
    <div *ngIf="selectedCalendarType === 'date'" class="calendar-input">
      <atom-date [title]="'DATES.Fecha'" (dateSelected)="onDateChange($event)"></atom-date>
    </div>
  </div>
</div>
